let Vue

function extend (Vue) {
	Vue.directive('inputUI', {
		inserted (el) {
			if (el.querySelector('input').value.trim() !== '') el.querySelector('label').classList.add('active')

			el.querySelector('input').addEventListener('focus', () => {
				el.querySelector('label').classList.add('active')
			})

			el.querySelector('input').addEventListener('blur', () => {
				if (el.querySelector('input').value.trim() === '') {
					el.querySelector('label').classList.remove('active')
				}
			})
		}
	})
}

function _install (_Vue) {
	Vue = _Vue
	extend(Vue)
}

let inputUI = function inputUI (options = {}) {}

inputUI.install = _install
inputUI.version = '0.0.1'

export default inputUI



// WEBPACK FOOTER //
// ./src/common/directives/inputUI.js